import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-client-autocomplete',
  templateUrl: './client-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})
export class ClientAutocompleteComponent {
  @Input() placeholder: string;
  items: Array<any> = [];
  input: string;
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {}

  getAllItems(): any {
    this.getAllClients();
  }

  getAllClients(): void {
    this.sharedService.getAllClients(this.input).subscribe(
      res => {
        this.items = res.results;
        this.isListVisible = this.items.length > 0 && this.input.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;
    this.input = item.name;
  }

  trackByFn(index: number): number {
    return index;
  }
}
